import React, { useEffect } from 'react';
import Flow, { FlowStepCallback } from 'components/Common/Flow/Flow';
import { Store } from 'store';
import { useDispatch, useSelector } from 'react-redux';
import getAddingToCartFlow from 'store/product/selector/getAddingToCartFlow';
import { AddToCartFlow } from 'store/product/types';
import { AvailableFlows, AvailablePopups } from 'store/app/types';
import showPopupOperation from 'store/app/operation/showPopupOperation';
import fetchFrameUpsellDataOperation from 'store/product/operation/fetchFrameUpsellDataOperation';
import getFrameUpsellData from 'store/product/selector/getFrameUpsellData';
import getSelectedBundleProducts from 'store/product/selector/getSelectedBundleProducts';
import { nextStepFlowAction } from 'store/app/slice';
import redirectToCartOperation from 'store/app/operation/redirectToCartOperation';
import useIsServer from 'hooks/useIsServer';
import ContinueShopingPopup from '../ContinueShopingPopup/ContinueShopingPopup';
import FrameUpsellPopup from '../FrameUpsellPopup/FrameUpsellPopup';

const PostAddToCartFlow = () => {
  const currentAddToCartFlow = useSelector(getAddingToCartFlow);
  const dispatch = useDispatch();
  const isServer = useIsServer();
  if (isServer) {
    return null;
  }

  useEffect(() => {
    if ([AddToCartFlow.addedToCart, AddToCartFlow.bundlingCompleted].includes(currentAddToCartFlow)) {
      dispatch(nextStepFlowAction(AvailableFlows.postAddToCart));
    }
  }, [currentAddToCartFlow]);

  const goToBasket = () => {
    dispatch(redirectToCartOperation());
  };

  const showFrameUpselllPopup: FlowStepCallback = async (getState: () => Store, nextStep: () => void) => {
    await dispatch(fetchFrameUpsellDataOperation());
    const isFrameUpsellDataAvailable = Boolean(getFrameUpsellData(getState()));
    const isBundledProductSelected = getSelectedBundleProducts(getState()).some(
      (selectedProduct) => selectedProduct.productId > 0,
    );
    if (isFrameUpsellDataAvailable && !isBundledProductSelected) {
      dispatch(showPopupOperation(AvailablePopups.frameUpsellPopup));
      return;
    }
    nextStep();
  };

  return (
    <>
      <ContinueShopingPopup />
      <FrameUpsellPopup />
      <Flow flowId={AvailableFlows.postAddToCart} flowSteps={[showFrameUpselllPopup, goToBasket]} />
    </>
  );
};

export default PostAddToCartFlow;
